export default "__VITE_ASSET__8yHCxlQG__"